"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbPassword = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sbTextbox = require("../sb-textbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbPassword = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbPassword, _PureComponent);

  var _super = _createSuper(SbPassword);

  function SbPassword(props) {
    var _this;

    _classCallCheck(this, SbPassword);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleInputRef", function (node) {
      var inputRef = _this.props.inputRef;
      _this.node = node;

      if (inputRef && typeof inputRef === 'function') {
        inputRef(node);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function () {
      window.getSelection().removeAllRanges();

      if (_this.node) {
        _this.node.focus();
      } // Move the setState to the end of the stack to maintain the cursor position.


      setTimeout(function () {
        _this.setState(function (prevState) {
          return {
            isVisible: !prevState.isVisible
          };
        });
      }, 1);
    });

    _this.state = {
      isVisible: false
    };
    return _this;
  }

  _createClass(SbPassword, [{
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;

      var _this$props = this.props,
          className = _this$props.className,
          controlVisibility = _this$props.controlVisibility,
          disabled = _this$props.disabled,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["className", "controlVisibility", "disabled", "id"]);

      var icon = isVisible ? 'sbi-eye-slash' : 'sbi-eye';
      var inputType = isVisible ? 'text' : 'password';
      var iconId = id ? "".concat(id, "-visibility-control") : null;
      return /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, _extends({}, rest, {
        className: (0, _classnames.default)(className, 'sb-password'),
        type: inputType,
        disabled: disabled,
        id: id,
        addonRight: controlVisibility ? /*#__PURE__*/_react.default.createElement("span", {
          id: iconId,
          className: "password-icon",
          onClick: !disabled ? this.handleOnClick : null
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: icon,
          disabled: disabled
        })) : /*#__PURE__*/_react.default.createElement("span", null),
        inputRef: this.handleInputRef
      }));
    }
  }]);

  return SbPassword;
}(_react.PureComponent);

exports.SbPassword = SbPassword;

_defineProperty(SbPassword, "propTypes", {
  className: _propTypes.default.string,
  controlVisibility: _propTypes.default.bool
});

_defineProperty(SbPassword, "defaultProps", {
  className: null,
  controlVisibility: true
});
//# sourceMappingURL=sb-password.js.map